import { ArrowClockwise } from "react-bootstrap-icons";

const RefreshButton = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "8px 16px",
      backgroundColor: "transparent",
      color: "#fff",
      border: "1px solid #fff",
      borderRadius: "8px",
      cursor: "pointer",
    }}
    aria-label="Refrescar"
    title="Refrescar"
  >
    <ArrowClockwise size={18} /> Actualizar
  </button>
);

export default RefreshButton;
